<app-password-guard *ngIf="!isPasswordVerified" (authenticated)="onPasswordVerified()"></app-password-guard>

<app-experiment-instruction
  *ngIf="isPasswordVerified && showPreparationScreen"
  [isVisible]="true"
  [message]="'請按一下滑鼠繼續'"
  (goNext)="onPreparationComplete()"
></app-experiment-instruction>

<div [class.blocked]="!isPasswordVerified || showPreparationScreen || !isExperimentInitialized">
  <app-experiment-instruction
    [isVisible]="showInstruction()"
    [message]="instructionMessage()"
    (goNext)="updateExperimentState()"
    (restartRequest)="continueExperiment()"
  ></app-experiment-instruction>
  <app-intensity-rating-demo
    [isVisible]="showIntensityRatingDemo()"
    (goNext)="updateExperimentState()"
  ></app-intensity-rating-demo>
  <app-experiment-trial
    [isVisible]="showTrial()"
    [trial]="currentTrial()"
    [currentTrialStage]="currentTrialStage()"
    [trialImgSrc]="trialImgSrc()"
    (practiceClassificationSelected)="updateLastPracticeClassificationCorrect($event)"
    (saveClassificationResponse)="saveClassificationResponse($event)"
    (saveIntensityResponse)="saveIntensityResponse($event)"
    (completeTrial)="taskComplete()"
  ></app-experiment-trial>
</div>
